import React from 'react';
import { useTranslation } from 'react-i18next';

import { SearchFacetMenuSelect, SearchFacets } from '@uncinc/react-searchkit';

import './style.scss';

const SearchAllContentFacets = () => {
  const { t } = useTranslation();

  return (
    <SearchFacets className="SearchAllContent__Facets">
      <SearchFacetMenuSelect
        className="Select__inner"
        attribute="type"
        // @ts-expect-error - title is not typed in the kitchen sink, but it does exist.
        title={t('searchkit.facets.type.title')}
        transformItems={(items) => items.map((item) => ({
          ...item,
          label: t(`searchkit.facets.type.options.${item.value}`),
        }))}
      />
    </SearchFacets>
  );
};

export default SearchAllContentFacets;
